import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseQuestionComponent } from '../base-question.component';

/**
 * Phone question component.
 * Displays and configures a phone number question.
 * Uses Angular signals inherited from BaseQuestionComponent.
 */
@Component({
  selector: 'app-phone-question',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './phone-question.component.html',
  styleUrl: './phone-question.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneQuestionComponent extends BaseQuestionComponent implements OnInit {
  placeholder: string = '';

  ngOnInit(): void {
    this.placeholder = this.question().placeholder || '';
  }

  onLabelChange(value: string): void {
    this.updateLabel(value);
  }

  onPlaceholderChange(value: string): void {
    this.placeholder = value;
    this.emitConfigChange({ placeholder: this.placeholder } as any);
  }

  onAdditionalInfoChange(value: string): void {
    this.updateAdditionalInfo(value);
  }

  onHelperTextChange(value: string): void {
    this.updateHelperText(value);
  }

  onRequiredToggle(): void {
    this.updateRequired(!this.question().isRequired);
  }
}
